<template >
  <article class="accessIndex" v-if="loaded">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Convenios
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="$router.push({name: 'agreement_new'})"
              >
                Nueva empresa
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="pagination_query=false;filterAgreements(true)"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="invitations"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td style="cursor:pointer;"@click="$router.push({name: 'agreement_invitations_index', params: {id: props.item.agreement_user_id,title:props.item.organization_name}})">{{ props.item.organization_name }}</td>
            <td>{{ props.item.quantity_entries }}</td>
            <td>{{ props.item.quantity_send }}</td>
            <td>{{ props.item.quantity_registered }}</td>
            <td>{{ props.item.quantity_used }}</td>
            <td>
              <div @click="dialog=true;selected_agreement_name=props.item.organization_name;selected_agreement_id=props.item.agreement_id;"class="accessIndex__agreement--add_pass">
                <p class="accessIndex__text--small_bold_gray">Agregar</p>
                <img src="../../../assets/img/add_circle.svg">
              </div>
            </td>
          </template>
        </v-data-table>
      </div>
      <div class="table_card_footer">
        <div v-if="invitations.length>0&& pages > 1" class="accessIndex__pagination">
          <v-pagination  color="light-blue darken-3" v-model="pagination.page" :length="pages"></v-pagination>
          <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
          <label class="accessIndex__pagination--current_text" v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}</label>
          <label class="accessIndex__pagination--current_text" v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
        </div>
      </div>
    </div>

    <template>
      <v-dialog v-model="dialog" persistent max-width="360px">

      <v-card class="accessIndex__agreement">
        <div class="invitation__new">
          <div class="invitation__new--title">
          <p class="invitation__new_text--title">Agregar pases - {{selected_agreement_name}}</p>
          </div>
          <div class="invitation__new--info_container">
            <div class="accessIndex__agreement--add_container">
              <div class="accessIndex__agreement--add">
                <v-hover>
                  <button @click="addQuantity(-1)" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="accessIndex__agreement--add_item">
                    <p>-</p>
                  </button>
                </v-hover>
                <input class="accessIndex__agreement--number_format " v-model="add_quantity"    >

                <v-hover>
                  <button @click="addQuantity(1)" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="accessIndex__agreement--add_item">
                    <p>+</p>
                  </button>
                </v-hover>
              </div>
            </div>
            <div class="invitation__new--actions">
						  <p class="invitation__buttons--blue" @click="dialog=false; addPassesToAgreement();">ENVIAR</p>
						  <p class="invitation__buttons--gray" @click="dialog=false;add_quantity=0; ">CANCELAR</p>
					  </div>
          </div>
        </div>
      </v-card>
          </v-dialog>
    </template>
  </article>

</template>

<script>
export default {
  data(){
    return{
      pagination_query:false,
      selected_agreement_name:'',
      selected_agreement_id:'',
      invitations_size:0,
      invitations: [],
      loaded: false,
      dialog: false,
      pages:2,
      add_quantity:1,
      pagination: {page:1,rowsPerPage:24},
      headers: [
        {text:'Empresa', value: 'organization_name'},
        {text:'P. autorizados', value: 'quantity_entries'},
        {text:'P. enviados', value: 'quantity_send'},
        {text:'P. registrados', value: 'quantity_registered'},
        {text:'P. ingresados', value: 'quantity_used'},
        {text:'', value: 'sum'}
      ]
    }
  },
   watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.filterAgreements();

       }

     },
     add_quantity:function (val, oldVal) {

       if(isNaN(val)||val==null||val==""){
         this.add_quantity=oldVal;
       }


       }
    }
    ,
  methods:{
    addQuantity(sum){
      if(parseInt(this.add_quantity)+sum>=0){
        this.add_quantity=parseInt(this.add_quantity)+sum;
      }
    },
    addPassesToAgreement(){
      var send_object={attributes:{}};
      send_object.attributes.agreement_admin_user_id=this.selected_agreement_id;
      // if(this.addQuantity==''||this.addQuantity==null){
      //   this.addQuantity=0;
      // }
      send_object.attributes.quantity=this.add_quantity;
      this.add_quantity=1;
      try {
        this.$http.post('agreements/add_agreement_entries',
          {
            data: this.encrypt(send_object).toString()
          }
          ,
          {
            headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }
      ).then(function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          console.table(response.body.data);
          this.add_quantity=0;
          this.filterAgreements(true);
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    filterAgreements(){
      if(!this.pagination_query){
        this.pagination.page=1;
      }
      try {
        this.$http.get('agreements/index_users',
        {
          params:{
            page:this.pagination.page
          },
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }
      ).then(function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.invitations = response.body.data
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          console.table(response.body.data)
          this.loaded = true
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }

    },
  },
  mounted(){
    // this.pagination.rowsPerPage=12;
    this.filterAgreements(true);

  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/agreements/Index.vue